export default __webpack_public_path__ + "static/media/10.e17997f0.png";